import React from 'react'
import Text from 'src/components/ts-components/Text'
import colors from '@sportninja/common/constants/appColors'

/** Header component for the ManageRefreshments modal */
const ModalHeader: React.FC = () => {
  return (
    <Text
      variant='heading3'
      weight='semiBold'
      color={colors.WHITE}
      textTransform='capitalize'
    >
      Choose Player/Team Official
    </Text>
  )
}

export default React.memo(ModalHeader)
